import React, { createContext, useContext, useState, useEffect } from "react";
import { initialValues } from "../components/organisms/forms/DistributorForm/initialValues";
import { categoriesOrder } from "../vars/orderLists";

const initData = {};

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const [data, setData] = useState(initData);

  useEffect(() => {
    const res = sessionStorage.getItem("data");
    const store = JSON.parse(res);
    setData(store);
    if (store === null || !store || !store.userCountry) {
      fetch("https://api.ozparts.eu/country")
        .then((response) => response.json())
        .then((response) => {
          setUserCountry(response);
        });
    }
    if (store === null || !store.options || !store.categories) {
      fetch("https://ozparts2.usermd.net/api/external/applications", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "getApplications",
          language: "polish",
          source: "pedderspl",
          manufacturergroup: "5f9bda55dcdf6b0c04f1878b",
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.options?.make) {
            setOptions([...new Set(responseJson.options.make.sort())]);
            setCategories([
              ...new Set(
                responseJson.options.categorydescription
                  .map((obj) => (obj === "" ? "OTHER" : obj.toUpperCase()))
                  .sort(
                    (a, b) =>
                      categoriesOrder.indexOf(a) - categoriesOrder.indexOf(b)
                  )
              ),
            ]);
          }
        });
    }
  }, []);

  const setAllData = (name, value) => {
    const res = sessionStorage.getItem("data");
    setData({ ...JSON.parse(res), [name]: value });
    sessionStorage.setItem(
      "data",
      JSON.stringify({ ...JSON.parse(res), [name]: value })
    );
  };

  const setBasketId = (id) => setAllData("basketId", id);
  const setBasketCount = (count) => setAllData("basketCount", count);
  const setBasket = (basket) => setAllData("basket", basket);
  const setSummary = (summary) => setAllData("summary", summary);
  const setUserCountry = (country) => setAllData("userCountry", country);
  const setBasketOptions = (options) => setAllData("basketOptions", options);
  const setOptions = (options) => setAllData("options", options);
  const setCategories = (categories) => setAllData("categories", categories);
  const setAddress = (address) => setAllData("address", address);

  const reset = () => {
    setAllData("basketCount", 0);
    setAllData("basketId", "");
    setAllData("basket", null);
    setAllData("summary", null);
    setAllData("basketOptions", null);
    setAllData("address", initialValues);
  };

  const value = {
    data,
    ...data,
    setBasket,
    setBasketId,
    setBasketCount,
    setSummary,
    setUserCountry,
    setAddress,
    reset,
    setOptions,
    setCategories,
    setBasketOptions,
  };

  return (
    <AppContext.Provider value={value}>{props.children}</AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);

export default AppContextProvider;
